<template>
  <div :style="`width:${dispW}px;height:${dispH}px;margin:0 auto`">
    <div style="width: 100%; width: 104%; position: relative; left: -13px">
      <h1 class="manualtitle">{{ title }}</h1>
    </div>
    <div class="wrapper-full" ref="trend"></div>
  </div>
</template>
<script>
import { Size } from "../../../mixins";
export default {
  name: "TrendChart",
  data() {
    return {};
  },
  mixins: [Size],
  props: {
    trendData: {
      type: Array,
      default: () => []
    },
    yName: {
      type: String,
      default: "(%)"
    },
    id: {
      type: String,
      default: ""
    },
    xName: {
      type: String,
      default: "(s)"
    },
    xFormater: {
      type: String | Function
    },
    xRange: {
      type: Object,
      default: () => {
        return {
          min: 0,
          max: 21,
          interval: undefined
        };
      }
    },
    title: {
      type: String,
      default: ""
    },
    yRange: {
      type: Object,
      default: () => {
        return {
          min: undefined,
          max: undefined
        };
      }
    },
    gridRight: {
      type: Number,
      default: 0
    },
    titleVisible: {
      type: Boolean,
      default: true
    },
    tearHeightxAxisData: {
      type: Array,
      default: null
    }
  },
  methods: {
    dryTrend() {
      let seriesdata = this.trendData;
      let option = {
        animation: false,
        title: {
          left: "center",
          text: this.title,
          textStyle: {
            color: "#fff",
            fontSize: 20,
            fontFamily: "Microsoft YaHei"
          },
          show: this.titleVisible
        },
        grid: {
          top: 50,
          left: 44,
          right: this.gridRight,
          bottom: 40
        },
        xAxis: {
          name: this.xName,
          type: "value",
          nameTextStyle: {
            fontSize: 16
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1
            }
          },
          // interval: this.xRange.interval,
          min: this.xRange.min,
          max: this.xRange.max,
          splitNumber: 7,
          axisLabel: {
            color: "#fff",
            fontSize: 20
            // formatter: xFormater
          },
          splitLine: {
            lineStyle: {
              color: "#445"
            }
          }
        },
        yAxis: {
          name: this.yName,
          nameTextStyle: {
            fontSize: 16
          },
          min: this.yRange.min,
          max: this.yRange.max,
          minorTick: {
            show: false
          },
          axisLabel: {
            color: "#fff",
            fontSize: 20
          },
          axisLine: {
            lineStyle: {
              color: "white",
              width: 1
            }
          },
          splitLine: {
            lineStyle: {
              color: "#445"
            }
          }
        },
        series: [
          {
            type: "line",
            data: seriesdata,
            showSymbol: false,
            boundaryGap: false, // 不留白，从原点开始
            clip: true,
            lineStyle: {
              color: "#66CCCC",
              width: 1
            }
          }
        ]
      };
      let xFormater = "";
      if (this.xRange.min === -6) {
        xFormater = function (value, index) {
          if (index === 0) return 6;
          else if (index === 1) return 4;
          else if (index === 2) return 2;
          else if (index === 3) return 0;
          else if (index === 4) return 2;
          else if (index === 5) return 4;
          else if (index === 6) return 6;
        };
        option.xAxis.interval = this.xRange.interval;
        option.xAxis.axisLabel.formatter = xFormater;
      }
      var main = this.$refs.trend;
      // console.log(main)
      var myChart = this.$echarts.init(main);
      myChart.setOption(option);
    },
    func(x) {
      x /= 10;
      return Math.sin(x) * Math.cos(x * 2 + 1) * Math.sin(x * 3 + 2) * 50;
    },
    generateData() {
      let data = [];
      for (let i = -200; i <= 200; i += 0.1) {
        data.push([i, this.func(i)]);
      }
      return data;
    }
  },
  watch: {
    trendData(newValue) {
      this.trendData = newValue;
      this.dryTrend();
    }
  },
  mounted() {
    this.generateData();
    this.dryTrend();
  }
};
</script>
<style lang="less" scoped>
.manualtitle {
  line-height: 40px;
  height: 40px;
  background: #606266;
  text-align: center;
  font-size: 23px;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/basic/TrendChart.vue